import { useState } from "react";
import { MapPin, Calendar, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import RetreatWaitlistModal from "@/components/RetreatWaitlistModal";

const RetreatsSection = ({ onOpenBooking }) => {
  const { t } = useTranslation();
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const [selectedRetreat, setSelectedRetreat] = useState("tulum");

  const retreats = [
    {
      key: "tulum",
      location: "Tulum, Mexico",
      season: t("retreats.tulum_season"),
      title: t("retreats.tulum_title"),
      description: t("retreats.tulum_desc"),
      image: "https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?auto=format&fit=crop&w=800&q=80",
    },
    {
      key: "bali",
      location: "Ubud, Bali",
      season: t("retreats.bali_season"),
      title: t("retreats.bali_title"),
      description: t("retreats.bali_desc"),
      image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=800&q=80",
    },
    {
      key: "brazil",
      location: "Chapada dos Guimarães, Brazil",
      season: t("retreats.brazil_season"),
      title: t("retreats.brazil_title"),
      description: t("retreats.brazil_desc"),
      image: "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=800&q=80",
    },
    {
      key: "costarica",
      location: "Nosara, Costa Rica",
      season: t("retreats.costarica_season"),
      title: t("retreats.costarica_title"),
      description: t("retreats.costarica_desc"),
      image: "https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=800&q=80",
    },
  ];

  const openWaitlist = (key) => {
    setSelectedRetreat(key);
    setWaitlistOpen(true);
  };

  return (
    <section
      id="retreats"
      data-testid="retreats-section"
      className="section-padding bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16">
          <span className="overline mb-4 block">{t("retreats.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl text-[#2C3524] leading-[1.1] mb-8">
            {t("retreats.titlePart1")}<br />
            <span className="text-[#C5A059] italic">{t("retreats.titlePart2")}</span>
          </h2>
          <p className="text-[#4A5543] text-lg md:text-xl font-light leading-relaxed">
            {t("retreats.intro")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {retreats.map((retreat, index) => (
            <div
              key={index}
              className="group cursor-pointer"
              data-testid={`retreat-${retreat.key}`}
              onClick={() => openWaitlist(retreat.key)}
            >
              <div className="relative overflow-hidden rounded-2xl mb-5 aspect-[4/5]">
                <img
                  src={retreat.image}
                  alt={retreat.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2C3524]/80 via-[#2C3524]/20 to-transparent" />
                <div className="absolute top-5 left-5 flex items-center gap-2 text-white/90 text-xs tracking-[0.15em] uppercase">
                  <MapPin className="w-3 h-3" />
                  {retreat.location}
                </div>
                <div className="absolute bottom-5 left-5 right-5">
                  <div className="flex items-center gap-2 text-[#DCC286] text-xs tracking-[0.15em] uppercase mb-2">
                    <Calendar className="w-3 h-3" />
                    {retreat.season}
                  </div>
                  <h3 className="font-heading text-2xl md:text-3xl text-white leading-tight">
                    {retreat.title}
                  </h3>
                </div>
              </div>
              <p className="text-[#4A5543] font-light text-sm leading-relaxed pr-4">
                {retreat.description}
              </p>
              <div className="mt-4 inline-flex items-center gap-2 text-[#C5A059] text-sm font-medium group-hover:gap-3 transition-all">
                {t("retreats.cta")}
                <ArrowRight className="w-4 h-4" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Retreat Waitlist Modal */}
      <RetreatWaitlistModal
        isOpen={waitlistOpen}
        onClose={() => setWaitlistOpen(false)}
        defaultRetreat={selectedRetreat}
      />
    </section>
  );
};

export default RetreatsSection;
